import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, useMultiStyleConfig, Image} from '@chakra-ui/react'

const PaymentIcons = ({icons}) => {
    const styles = useMultiStyleConfig('Footer')
    return (
        <>
            <Flex {...styles.paymentsSection}>
                {icons?.length > 0 &&
                    icons.map(({icon}) => (
                        <Box {...styles.paymentIcons} key={icon?.title}>
                            <Image loading="lazy" src={icon?.url} alt={icon?.title} />
                        </Box>
                    ))}
            </Flex>
        </>
    )
}

PaymentIcons.propTypes = {
    icons: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({url: PropTypes.string, title: PropTypes.string}),
        }),
    ),
}

export default PaymentIcons
